export default "__VITE_ASSET__oEdyS0TU__"